<template>
  <!-- 新增角色 -->
  <div class="orderRefund">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form
        :model="addForm"
        label-position="rigth"
        label-width="100px"
        style="width: 100%"
        :rules="addFormRule"
        ref="addForm"
      >
        <div class="form-item-wrap">
          <el-form-item label="订单编号" prop="id">
            <el-input
              v-model="addForm.id"
              placeholder="订单编号"
              readonly
              class="elInputBdNone"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户编号" prop="userId">
            <el-input
              v-model="addForm.userId"
              placeholder="客户编号"
              readonly
              class="elInputBdNone"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户姓名" prop="userName">
            <el-input
              v-model="addForm.userName"
              placeholder="客户姓名"
              readonly
              class="elInputBdNone"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="已支付金额" prop="payPrice">
            <el-input
              v-model="addForm.payPrice"
              placeholder="已支付金额"
              readonly
              class="elInputBdNone"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="已退款金额" prop="refPrice">
            <el-input
              v-model="addForm.refPrice"
              placeholder="已退款金额"
              readonly
              class="elInputBdNone"
            ></el-input>
          </el-form-item>
        </div>
        <div
          v-if="addForm.postage && parseFloat(addForm.postage) > 0"
          class="form-item-wrap"
        >
          <el-form-item label="邮费">
            <!-- <el-input v-model="addForm.postage" placeholder="邮费" readonly class="elInputBdNone"></el-input> -->

            <div style="display: flex; margin-left: 15px">
              <label>{{ addForm.postage }}</label>
              <el-checkbox
                style="margin-left: 20px"
                label="是否退邮费"
                v-model="addForm.returnpost"
                @change="postclick"
              ></el-checkbox>
            </div>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item
            class="el-form-required-true"
            label="商品列表"
            prop="list"
          >
            <el-table
              :data="list"
              stripe
              border
              tooltip-effect="dark"
              @selection-change="selectionChange"
              style="width: 90%"
            >
              <el-table-column align="center" width="50" type="selection">
              </el-table-column>
              <el-table-column
                prop="id"
                align="center"
                show-overflow-tooltip
                label="商品编号"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                align="center"
                show-overflow-tooltip
                label="商品名称"
              >
              </el-table-column>
              <el-table-column
                prop="spec"
                label="商品规格"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="factory"
                label="生产厂家"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="price"
                label="价格"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="num"
                label="数量"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="retNum"
                label="已退数量"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="refNum"
                label="退款数量"
                align="center"
                width="200"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-input-number
                    v-model="scope.row.refNum"
                    :min="1"
                    style="width: 80%"
                    :max="scope.row.refNumMax"
                    @change="setRefNum(scope.row)"
                  ></el-input-number>
                </template>
              </el-table-column>
              <el-table-column
                prop="allPrice"
                label="金额合计"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
            </el-table>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="退款金额" prop="allPrice">
            <el-input-number
              v-model="addForm.allPrice"
              :min="0"
              style="width: 200px"
              :max="addForm.allPriceMax"
            >
            </el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap" style="margin-top: 20px">
          <el-form-item label="" prop="">
            <el-button type="primary" @click="submitForm">提交</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "orderRefund",
  data() {
    return {
      /**新增表单 */
      addForm: {
        id: "", // 订单编号
        userId: "", // 客户编号
        userName: "", // 客户名称
        payPrice: "", // 已支付金额
        refPrice: "", // 已退款金额
        list: [], // 商品列表
        allPriceMax: 0, // 可退款金额
        allPrice: 0, // 退款金额
        returnpost: false, //是否退运费
      },
      /**新增表单规则 */
      addFormRule: {
        id: [mustFill], // 分类ID
        userId: [mustFill], // 客户编号
        //userName: [mustFill], // 客户名称
        payPrice: [mustFill], // 已支付金额
        refPrice: [mustFill], // 已退款金额
        allPrice: [mustFill], // 退款金额
      },
      list: [], // 商品列表
    };
  },
  mounted() {
    //接收role传递参数
    let row = JSON.parse(decodeURIComponent(this.$route.query.row));
    if (row) {
      this.addForm.id = row.id;
      this.addForm.payPrice = row.payPrice;
      this.addForm.refPrice = row.refPrice;
      this.addForm.allPriceMax = parseFloat(
        (parseFloat(row.payPrice) - parseFloat(row.refPrice)).toFixed(2)
      );
      this.addForm.postage = row.postage;
      this.getData();
    }
  },
  methods: {
    postclick() {
      this.setAllPrice();
      console.log(this.addForm.returnpost);
    },
    // 获取文章详情
    getData() {
      let data = {
        type: "GetOrderDetail",
        order_no: this.addForm.id,
      };
      let proc = "Proc_Admin_Order"; // 存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        url:
          "order/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          if (res.flag == 0) {
            let list = res.table1 || [];
            let item = list[0];
            this.addForm.userId = item.username;
            this.addForm.userName = item.name;
            this.list = list.map((item) => {
              let refNum =
                parseFloat(item.quantity) - parseFloat(item.ReturnNum);
              return {
                id: item.goodscode, // 商品编号
                sortId: item.sortId, // 序号
                name: item.sub_title, // 商品名称
                spec: item.drug_spec, // 商品规格
                factory: item.drug_factory, // 生产厂家
                price: item.real_price, // 价格
                num: item.quantity, // 数量
                retNum: item.ReturnNum, // 已退数量
                refNumMax: refNum, // 最大退款数量
                refNum: refNum, // 退款数量
                allPrice: (refNum * parseFloat(item.real_price)).toFixed(2), // 金额合计
              };
            });
            this.setAllPrice();
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 表格选择
    selectionChange(list) {
      this.addForm.list = list;
      this.setAllPrice();
    },
    // 计算商品金额合计
    setRefNum(row) {
      row.allPrice = (row.refNum * parseFloat(row.price)).toFixed(2);

      this.setAllPrice();
    },
    // 计算商品总金额
    setAllPrice() {
      let allPrice = 0;
      if (this.addForm.returnpost) {
        allPrice = parseFloat(this.addForm.postage);
      }
      // console.log(allPrice)
      this.addForm.list.forEach((item) => {
        allPrice = parseFloat(
          (allPrice + parseFloat(item.allPrice)).toFixed(2)
        );
      });

      this.addForm.allPrice = allPrice;
    },
    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          if (!this.addForm.list.length && !this.addForm.returnpost) {
            this.$message({
              message: "请选择商品或邮费",
              type: "warning",
            });
            return;
          }
          let list = this.addForm.list.map(
            (item) => item.sortId + "|" + item.refNum
          );
          if (this.addForm.returnpost) {
            //退邮费
            list.push("10000|" + this.addForm.postage);
          }
          let data = {
            type: "SaveOrderRefund",
            orderNo: this.addForm.id,
            RefundAmount: this.addForm.allPrice,
            list: list.join(","),
          };
          let proc = "Proc_OrderRefund"; // 存储过程名
          let type = "ReturnListNumber";
          this.$requestSys({
            url:
              "order/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.goBack();
              } else {
                //失败提示
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.orderRefund {
  width: 100%;
  height: 100%;
}
</style>
